import { m } from 'framer-motion';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

import { fShortenNumber } from 'src/utils/format-number';

import { useCheckoutContext } from 'src/sections/checkout/context';

import { Iconify } from '../iconify';
import { varTap, varHover, transitionTap } from '../animate';

// ----------------------------------------------------------------------

export function ButtonAddToCart({ product, preview, hideTotal, sx, ...other }) {
  const { onAddToCart } = useCheckoutContext();

  const handleAddCart = () =>
    onAddToCart({
      quantity: 1,
      id: product.id,
      cod: product.cod,
      sku: product.sku,
      card: product.card,
      name: product.name,
      country: product.country,
      coverUrl: product.coverUrl,
      sellerID: product.sellerID,
      shipping: product.shipping,
      available: product.available,
      priceSale: product.priceSale,
      size: [product.sizes[0] ?? ''],
      transaction: product.transaction,
      colors: [product.colors[0] ?? ''],
      numberFormat: product.numberFormat,
    });

  return (
    <Box
      sx={[
        {
          textAlign: 'center',
          color: 'common.white',
          filter: 'drop-shadow(0 1px 1px rgba(0, 0, 0, .24))',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <IconButton
        size="small"
        color="inherit"
        whileTap={varTap()}
        component={m.button}
        whileHover={varHover(1.08)}
        transition={transitionTap()}
        onClick={() => !preview && product.available && handleAddCart()}
        {...other}
      >
        <Iconify
          icon="solar:cart-plus-bold"
          sx={{ width: { xs: 32, md: 26 }, height: { xs: 32, md: 26 } }}
        />
      </IconButton>

      {!hideTotal && <Box sx={{ typography: 'caption' }}>{fShortenNumber(product.totalSales)}</Box>}
    </Box>
  );
}
